import * as Tone from 'tone';
const tickInterval = '8i';
const intervalTicks = Tone.Time(tickInterval).toTicks();
class Envelope {
    constructor(target, envelopes, clip) {
        // tslint:disable-next-line
        this._envelopes = [];
        this.rampTime = Tone.Time(tickInterval).toSeconds();
        this.startTick = 0;
        /**
         *  The callback function for Tone.Loop. This will calculate the current envelope value and set the target Param to this value.
         *  @param  {Number} Time
         *  @private
         */
        this.tick = time => {
            const endTime = time + this.rampTime;
            const tick = Tone.Transport.ticks + intervalTicks;
            if (endTime > Tone.now()) {
                // next frame better
                const value = this.valueForTransportTick(tick);
                this.target.exponentialRampToValueAtTime(value, endTime);
            }
            if (this.clip.loop === false) {
                const startRelative = this.clip.startRelative;
                const loopEnd = this.clip._loopEnd;
                const startTick = this.startTick;
                const tickToCalculate = tick - startTick + startRelative;
                if (tickToCalculate >= loopEnd) {
                    this.stop(0);
                }
            }
        };
        this.target = target;
        this.envelopes = envelopes;
        this.tickLoop = new Tone.Loop(this.tick, tickInterval);
        this.clip = clip;
    }
    set envelopes(envelopes) {
        this._envelopes = [];
        for (const envelope of envelopes) {
            const [tick, value] = envelope;
            this._envelopes.push([Tone.TransportTime(tick), value]);
        }
    }
    /**
     *  Returns the value of the envelope for tick without taking looping and start time into account.
     *  Use valueForTransportTick() to get the envelope value relative to the start time and loop settings.
     *  @param  {Number} Tick
     *  @returns {Number} Envelope value
     */
    valueForRawTick(tick) {
        for (let y = this._envelopes.length; y; y--) {
            const envelope = this._envelopes[y - 1];
            const envelopeTick = envelope[0].toTicks();
            if (envelopeTick <= tick) {
                const nextEnvelope = this._envelopes[y];
                if (nextEnvelope) {
                    const nextEnvelopeTick = nextEnvelope[0].toTicks();
                    const distance = nextEnvelopeTick - envelopeTick;
                    const tickProgress = tick - envelopeTick;
                    const progress = tickProgress / distance;
                    const difference = nextEnvelope[1] - envelope[1];
                    const value = envelope[1] + difference * progress;
                    return value;
                }
                return envelope[1];
            }
        }
        return this._envelopes[0][1];
    }
    /**
     *  Returns the value of the envelope for a Transport tick. This tick can be passed from Tone.Transport.ticks and does not need to fall inside the bounds of the envelope.
     *  @param  {Number} Tick
     *  @returns {Number} Envelope value
     */
    valueForTransportTick(tick) {
        const startRelative = this.clip.startRelative;
        const loop = this.clip.loop; // eslint-disable-line no-unused-vars
        const loopStart = this.clip._loopStart;
        const loopEnd = this.clip._loopEnd;
        const startTick = this.startTick;
        const tickToCalculate = tick - startTick + startRelative;
        if (tickToCalculate >= 0) {
            const length = loopEnd - loopStart;
            return this.valueForRawTick(loopStart + (tickToCalculate % length));
        }
        else {
            return this.valueForRawTick(loopStart + tickToCalculate);
        }
    }
    start(time) {
        this.startTick =
            time instanceof Tone.TransportTimeClass ? time.toTicks() : time;
        this.tickLoop.start(this.startTick);
    }
    stop(time) {
        this.tickLoop.stop(time);
    }
}
export default Envelope;
//# sourceMappingURL=Envelope.js.map